/** 车辆相关开始 */
export default [
  {
    path: '/car/carDetail',
    name: 'carDetail',
    component: () => import(/* webpackChunkName: "carDetail" */ '../../views/car/CarDetail.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/car/handbook',
    name: 'handbook',
    component: () => import(/* webpackChunkName: "handbook" */ '../../views/car/handbook/Handbook.vue'),
    meta: {
      title: '车辆手册',
    },
  },
  {
    path: '/car/handbook/search',
    name: 'handbookSearch',
    component: () => import(/* webpackChunkName: "searchHandbook" */ '../../views/car/handbook/HandbookSearch.vue'),
    meta: {
      title: '车辆手册',
    },
  },
  {
    path: '/car/handbook/detail',
    name: 'handbookDetail',
    component: () =>
      import(/* webpackChunkName: "searchHandbookDetail" */ '../../views/car/handbook/HandbookDetail.vue'),
    meta: {
      title: '车辆手册',
    },
  },
]
